import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const AnalyticsReporting = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="relative bg-gray-900">
            <div className="absolute inset-0">
              <img
                className="w-full h-full object-cover opacity-30"
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                alt="Analytics reporting"
              />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
              <div className="text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                  <span className="block">Analytics & Performance Reporting</span>
                </h1>
                <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-100">
                  Data-driven insights to measure, optimize, and prove your marketing ROI.
                </p>
                <div className="mt-10">
                  <Link
                    to="/contact"
                    className="inline-block bg-indigo-600 py-3 px-8 border border-transparent rounded-md text-base font-medium text-white hover:bg-indigo-700"
                  >
                    Get A Demo
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            {/* Value Proposition */}
            <div className="bg-primary-50 rounded-xl p-8 mb-16">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">Why Analytics Matter</h2>
                  <p className="text-gray-600 mb-4">
                    In today's digital landscape, every click, impression, and conversion tells a story. Our analytics services transform raw data into strategic insights that drive growth.
                  </p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-start">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="ml-2">Measure what matters with custom KPIs</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="ml-2">Uncover hidden opportunities in your data</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="ml-2">Make confident decisions with real-time dashboards</span>
                    </li>
                  </ul>
                </div>
                <div className="mt-8 lg:mt-0">
                  <img
                    className="w-full rounded-lg shadow-lg"
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                    alt="Marketing analytics dashboard"
                  />
                </div>
              </div>
            </div>

            {/* Services Offered */}
            <div className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Our Analytics Services
              </h2>
              <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {/* Service 1 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Custom Dashboard Development</h3>
                  <p className="text-gray-600">
                    Tailored dashboards that consolidate all your marketing data into a single, actionable view with your key metrics front and center.
                  </p>
                </div>

                {/* Service 2 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">ROI Attribution Modeling</h3>
                  <p className="text-gray-600">
                    Multi-touch attribution to understand which channels and campaigns are truly driving conversions and revenue.
                  </p>
                </div>

                {/* Service 3 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Performance Benchmarking</h3>
                  <p className="text-gray-600">
                    Compare your metrics against industry standards to identify strengths and opportunities for improvement.
                  </p>
                </div>

                {/* Service 4 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Automated Reporting</h3>
                  <p className="text-gray-600">
                    Scheduled, white-labeled reports delivered to stakeholders with key insights and recommendations.
                  </p>
                </div>

                {/* Service 5 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Conversion Rate Optimization</h3>
                  <p className="text-gray-600">
                    Data-backed recommendations to improve your website and campaign conversion performance.
                  </p>
                </div>

                {/* Service 6 */}
                <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Analytics Implementation</h3>
                  <p className="text-gray-600">
                    Proper setup of Google Analytics, Google Tag Manager, and other tracking tools to ensure data accuracy.
                  </p>
                </div>
              </div>
            </div>

            {/* Reporting Samples */}
            <div className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Sample Report Highlights
              </h2>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
                    <h3 className="font-medium text-gray-900 mb-2">Executive Summary</h3>
                    <img
                      src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                      alt="Executive summary report"
                      className="w-full h-auto rounded"
                    />
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
                    <h3 className="font-medium text-gray-900 mb-2">Channel Performance</h3>
                    <img
                      src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                      alt="Channel performance report"
                      className="w-full h-auto rounded"
                    />
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
                    <h3 className="font-medium text-gray-900 mb-2">Conversion Funnel</h3>
                    <img
                      src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                      alt="Conversion funnel report"
                      className="w-full h-auto rounded"
                    />
                  </div>
                </div>
                <div className="mt-6 text-center">
                  <Link
                    to="/contact"
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                  >
                    Request Sample Reports
                  </Link>
                </div>
              </div>
            </div>

            {/* CTA Section */}
            <div className="bg-primary rounded-xl shadow-xl overflow-hidden">
              <div className="px-6 py-12 sm:p-16">
                <div className="text-center">
                  <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                    <span className="block">Ready to Transform Your Data</span>
                    <span className="block text-primary-200">Into Strategic Insights?</span>
                  </h2>
                  <p className="mt-4 max-w-3xl text-xl text-gray-300 mx-auto">
                    Our analytics experts will help you measure what matters and optimize for growth.
                  </p>
                  <div className="mt-8 flex justify-center">
                    <div className="inline-flex rounded-md shadow">
                      <Link
                        to="/contact"
                        className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary bg-white hover:bg-gray-50"
                      >
                        Get Started
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default AnalyticsReporting